import Vue from 'vue';
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from "../const";
import {
  ADD_BLACK_LIST_REQUISITE,
  ADD_BLACK_LIST_USER, CHANGE_EXCHANGE_ONLINE_STATUS,
  DELETE_BLACK_LIST_REQUISITE,
  DELETE_BLACK_LIST_USER,
  DISABLE_INTERBANK, DISABLE_TRAFFIC_SPILL,
  EDIT_EXCHANGE_ACTIVE, EDIT_EXCHANGE_MAX_AMOUNT,
  EDIT_EXCHANGE_MIN_AMOUNT, EDIT_EXCHANGE_PAYMENT_SYSTEM,
  EDIT_INTERBANK_RATE_PERCENT,
  EDIT_TRAFFIC_SPILL_AMOUNT,
  ENABLE_INTERBANK,
  ENABLE_TRAFFIC_SPILL,
  GET_EXCHANGE_SETTINGS, LOAD_BANKS_LIST,
  LOAD_BLACK_LIST_REQUISITES,
  LOAD_BLACK_LIST_USERS,
  LOAD_EXCHANGE_INFO, LOAD_EXCHANGE_STATS,
  LOAD_INTERBANKS, LOAD_QR_INTERBANKS,
  RESET_EXCHANGE
} from '../const/exchange';

export default {
  namespaced: true,
  state: {
    name: '',
    active: false,
    activeSbp: false,
    activeBankAccount: false,
    activeForeignCard: false,
    activeForeignSbp: false,
    activeSim: false,
    activeQR: false,
    online: false,
    balance: 0,
    balanceUpdated: 0,
    rate: { source: '', value: 0, updated: 0 },
    rate_exchange: { value: 0, updated: 0 },
    wallet: '',
    minExchangeAmount: 0,
    minExchangeAmountSbp: 0,
    minExchangeAmountBankAccount: 0,
    minExchangeAmountForeignCard: 0,
    minExchangeAmountForeignSbp: 0,
    minExchangeAmountSim: 0,
    minExchangeAmountQR: 0,
    maxExchangeAmount: 0,
    maxExchangeAmountSbp: 0,
    maxExchangeAmountBankAccount: 0,
    maxExchangeAmountForeignCard: 0,
    maxExchangeAmountForeignSbp: 0,
    maxExchangeAmountSim: 0,
    maxExchangeAmountQR: 0,
    blackListUsers: {
      list: [],
      pagination: {},
    },
    blackListRequisites: {
      list: [],
      pagination: {},
    },
    interBanks: {
      enabled: [],
      disabled: [],
    },
    qrInterBanks: {
      enabled: [],
      disabled: [],
    },
    stats: {},
    deeplinksBanks: [],
    qrBanks: [],
    banksList: [],
  },
  getters: {
    exchangeInfo: state => { return {
      name: state.name,
      balance: state.balance,
      balanceUpdated: new Date(state.balanceUpdated).toLocaleString(),
      rate: { ...state.rate, updated: new Date(state.rate.updated).toLocaleString() },
      rate_exchange: { ...state.rate_exchange, updated: new Date(state.rate_exchange.updated).toLocaleString() },
      wallet: state.wallet,
      active: state.active,
      minExchangeAmount: state.minExchangeAmount,
      maxExchangeAmount: state.maxExchangeAmount,
      activeSbp: state.activeSbp,
      minExchangeAmountSbp: state.minExchangeAmountSbp,
      maxExchangeAmountSbp: state.maxExchangeAmountSbp,
      activeBankAccount: state.activeBankAccount,
      minExchangeAmountBankAccount: state.minExchangeAmountBankAccount,
      maxExchangeAmountBankAccount: state.maxExchangeAmountBankAccount,
      activeForeignCard: state.activeForeignCard,
      minExchangeAmountForeignCard: state.minExchangeAmountForeignCard,
      maxExchangeAmountForeignCard: state.maxExchangeAmountForeignCard,
      activeForeignSbp: state.activeForeignSbp,
      minExchangeAmountForeignSbp: state.minExchangeAmountForeignSbp,
      maxExchangeAmountForeignSbp: state.maxExchangeAmountForeignSbp,
      activeSim: state.activeSim,
      minExchangeAmountSim: state.minExchangeAmountSim,
      maxExchangeAmountSim: state.maxExchangeAmountSim,
      activeQR: state.activeQR,
      minExchangeAmountQR: state.minExchangeAmountQR,
      maxExchangeAmountQR: state.maxExchangeAmountQR,
      online: state.online,
    }},
    blackListUsers: state => state.blackListUsers,
    blackListRequisites: state => state.blackListRequisites,
    enabledInterBanks: state => state.interBanks.enabled,
    disabledInterBanks: state => state.interBanks.disabled,
    enabledQrInterBanks: state => state.qrInterBanks.enabled,
    disabledQrInterBanks: state => state.qrInterBanks.disabled,
    stats: state => state.stats,
    deeplinksBanks: state => state.deeplinksBanks,
    qrBanks: state => state.qrBanks,
    banksList: state => state.banksList,
  },
  actions: {
    [LOAD_EXCHANGE_INFO]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_EXCHANGE_INFO,
        namespace: 'exchange',
      }, {root: true});
    },
    [GET_EXCHANGE_SETTINGS]: async ({ dispatch }) => {
      const request = await dispatch(HTTP_GET, {
        method: GET_EXCHANGE_SETTINGS,
        namespace: 'exchange',
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_BANKS_LIST]: async ({ dispatch }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_BANKS_LIST,
        namespace: 'exchange',
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [EDIT_EXCHANGE_ACTIVE]: async ({ dispatch, commit }, body) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_EXCHANGE_ACTIVE,
        namespace: 'exchange',
        no_commit: true,
        body,
      }, {root: true});
      commit(EDIT_EXCHANGE_ACTIVE, body);
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [EDIT_EXCHANGE_MIN_AMOUNT]: async ({ dispatch, commit }, body) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_EXCHANGE_MIN_AMOUNT,
        namespace: 'exchange',
        no_commit: true,
        body,
      }, {root: true});
      commit(EDIT_EXCHANGE_MIN_AMOUNT, body);
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [EDIT_EXCHANGE_MAX_AMOUNT]: async ({ dispatch, commit }, body) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_EXCHANGE_MAX_AMOUNT,
        namespace: 'exchange',
        no_commit: true,
        body,
      }, {root: true});
      commit(EDIT_EXCHANGE_MAX_AMOUNT, body);
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [EDIT_EXCHANGE_PAYMENT_SYSTEM]: async ({ dispatch, commit }, body) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_EXCHANGE_PAYMENT_SYSTEM,
        namespace: 'exchange',
        no_commit: true,
        body,
      }, {root: true});
      commit(EDIT_EXCHANGE_PAYMENT_SYSTEM, body);
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [CHANGE_EXCHANGE_ONLINE_STATUS]: async ({ dispatch, commit }, body) => {
      const request = await dispatch(HTTP_PUT, {
        method: CHANGE_EXCHANGE_ONLINE_STATUS,
        namespace: 'exchange',
        no_commit: true,
        body,
      }, {root: true});
      commit(CHANGE_EXCHANGE_ONLINE_STATUS, body);
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_BLACK_LIST_USERS]: async ({ dispatch, commit }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_BLACK_LIST_USERS,
        namespace: 'exchange',
        params,
      }, {root: true});
    },
    [ADD_BLACK_LIST_USER]: async ({ dispatch }, body) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_BLACK_LIST_USER,
        namespace: 'exchange',
        body,
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [DELETE_BLACK_LIST_USER]: async ({ dispatch }, user) => {
      const request = await dispatch(HTTP_DELETE, {
        method: DELETE_BLACK_LIST_USER,
        namespace: 'exchange',
        body: { user },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_BLACK_LIST_REQUISITES]: async ({ dispatch, commit }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_BLACK_LIST_REQUISITES,
        namespace: 'exchange',
        params,
      }, {root: true});
    },
    [ADD_BLACK_LIST_REQUISITE]: async ({ dispatch }, body) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_BLACK_LIST_REQUISITE,
        namespace: 'exchange',
        body,
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [DELETE_BLACK_LIST_REQUISITE]: async ({ dispatch }, requisite) => {
      const request = await dispatch(HTTP_DELETE, {
        method: DELETE_BLACK_LIST_REQUISITE,
        namespace: 'exchange',
        body: { requisite },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_INTERBANKS]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_INTERBANKS,
        namespace: 'exchange',
        params: { interbank_type: 'sbp' },
      }, {root: true});
    },
    [LOAD_QR_INTERBANKS]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_QR_INTERBANKS,
        namespace: 'exchange',
        params: { interbank_type: 'qr' },
      }, {root: true});
    },
    [ENABLE_INTERBANK]: async ({ dispatch }, { id, min_amount, interbank_type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: ENABLE_INTERBANK,
        namespace: 'exchange',
        replace: { id },
        body: { min_amount, interbank_type },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [DISABLE_INTERBANK]: async ({ dispatch }, { id, interbank_type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: DISABLE_INTERBANK,
        namespace: 'exchange',
        replace: { id },
        body: { interbank_type },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [EDIT_TRAFFIC_SPILL_AMOUNT]: async ({ dispatch }, { id, traffic_spill_amount, interbank_type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_TRAFFIC_SPILL_AMOUNT,
        namespace: 'exchange',
        replace: { id },
        body: { traffic_spill_amount, interbank_type },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [EDIT_INTERBANK_RATE_PERCENT]: async ({ dispatch }, { id, rate_percent, interbank_type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_INTERBANK_RATE_PERCENT,
        namespace: 'exchange',
        replace: { id },
        body: { rate_percent, interbank_type },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [ENABLE_TRAFFIC_SPILL]: async ({ dispatch }, { id, interbank_type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: ENABLE_TRAFFIC_SPILL,
        namespace: 'exchange',
        replace: { id },
        body: { interbank_type },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [DISABLE_TRAFFIC_SPILL]: async ({ dispatch }, { id, interbank_type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: DISABLE_TRAFFIC_SPILL,
        namespace: 'exchange',
        replace: { id },
        body: { interbank_type },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_EXCHANGE_STATS]: async ({ dispatch, commit }, body) => {
      await dispatch(HTTP_POST, {
        method: LOAD_EXCHANGE_STATS,
        namespace: 'exchange',
        body,
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_BLACK_LIST_USERS]: (state, { data }) => {
      Vue.set(state.blackListUsers, 'list', data.list);
      Vue.set(state.blackListUsers, 'pagination', data.pagination);
    },
    [LOAD_BLACK_LIST_REQUISITES]: (state, { data }) => {
      Vue.set(state.blackListRequisites, 'list', data.list);
      Vue.set(state.blackListRequisites, 'pagination', data.pagination);
    },
    [LOAD_EXCHANGE_INFO]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'name', data.name);
        Vue.set(state, 'balance', data.balance);
        Vue.set(state, 'balanceUpdated', data.balanceUpdated);
        Vue.set(state, 'wallet', data.wallet);
        Vue.set(state, 'rate', data.rate);
        Vue.set(state, 'rate_exchange', data.rate_exchange);
        Vue.set(state, 'active', data.active);
        Vue.set(state, 'minExchangeAmount', data.minExchangeAmount);
        Vue.set(state, 'maxExchangeAmount', data.maxExchangeAmount);
        Vue.set(state, 'activeSbp', data.activeSbp);
        Vue.set(state, 'minExchangeAmountSbp', data.minExchangeAmountSbp);
        Vue.set(state, 'maxExchangeAmountSbp', data.maxExchangeAmountSbp);
        Vue.set(state, 'activeBankAccount', data.activeBankAccount);
        Vue.set(state, 'minExchangeAmountBankAccount', data.minExchangeAmountBankAccount);
        Vue.set(state, 'maxExchangeAmountBankAccount', data.maxExchangeAmountBankAccount);
        Vue.set(state, 'activeForeignCard', data.activeForeignCard);
        Vue.set(state, 'minExchangeAmountForeignCard', data.minExchangeAmountForeignCard);
        Vue.set(state, 'maxExchangeAmountForeignCard', data.maxExchangeAmountForeignCard);
        Vue.set(state, 'activeForeignSbp', data.activeForeignSbp);
        Vue.set(state, 'minExchangeAmountForeignSbp', data.minExchangeAmountForeignSbp);
        Vue.set(state, 'maxExchangeAmountForeignSbp', data.maxExchangeAmountForeignSbp);
        Vue.set(state, 'activeSim', data.activeSim);
        Vue.set(state, 'minExchangeAmountSim', data.minExchangeAmountSim);
        Vue.set(state, 'maxExchangeAmountSim', data.maxExchangeAmountSim);
        Vue.set(state, 'activeQR', data.activeQR);
        Vue.set(state, 'minExchangeAmountQR', data.minExchangeAmountQR);
        Vue.set(state, 'maxExchangeAmountQR', data.maxExchangeAmountQR);
        Vue.set(state, 'deeplinksBanks', data.deeplinksBanks);
        Vue.set(state, 'qrBanks', data.qrBanks);
        Vue.set(state, 'online', data.online);
      }
    },
    [GET_EXCHANGE_SETTINGS]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'name', data.name);
        Vue.set(state, 'balance', data.balance);
        Vue.set(state, 'active', data.active);
        Vue.set(state, 'minExchangeAmount', data.minExchangeAmount);
        Vue.set(state, 'maxExchangeAmount', data.maxExchangeAmount);
        Vue.set(state, 'activeSbp', data.activeSbp);
        Vue.set(state, 'minExchangeAmountSbp', data.minExchangeAmountSbp);
        Vue.set(state, 'maxExchangeAmountSbp', data.maxExchangeAmountSbp);
        Vue.set(state, 'activeBankAccount', data.activeBankAccount);
        Vue.set(state, 'minExchangeAmountBankAccount', data.minExchangeAmountBankAccount);
        Vue.set(state, 'maxExchangeAmountBankAccount', data.maxExchangeAmountBankAccount);
        Vue.set(state, 'activeForeignCard', data.activeForeignCard);
        Vue.set(state, 'minExchangeAmountForeignCard', data.minExchangeAmountForeignCard);
        Vue.set(state, 'maxExchangeAmountForeignCard', data.maxExchangeAmountForeignCard);
        Vue.set(state, 'activeForeignSbp', data.activeForeignSbp);
        Vue.set(state, 'minExchangeAmountForeignSbp', data.minExchangeAmountForeignSbp);
        Vue.set(state, 'maxExchangeAmountForeignSbp', data.maxExchangeAmountForeignSbp);
        Vue.set(state, 'activeSim', data.activeSim);
        Vue.set(state, 'minExchangeAmountSim', data.minExchangeAmountSim);
        Vue.set(state, 'maxExchangeAmountSim', data.maxExchangeAmountSim);
        Vue.set(state, 'activeQR', data.activeQR);
        Vue.set(state, 'minExchangeAmountQR', data.minExchangeAmountQR);
        Vue.set(state, 'maxExchangeAmountQR', data.maxExchangeAmountQR);
      }
    },
    [LOAD_BANKS_LIST]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'banksList', data);
      }
    },
    [EDIT_EXCHANGE_PAYMENT_SYSTEM]: (state, { paymentSystem, active, min, max }) => {
      if (paymentSystem === 'card') {
        Vue.set(state, 'active', active);
        Vue.set(state, 'minExchangeAmount', min);
        Vue.set(state, 'maxExchangeAmount', max);
      } else if (paymentSystem === 'sbp') {
        Vue.set(state, 'activeSbp', active);
        Vue.set(state, 'minExchangeAmountSbp', min);
        Vue.set(state, 'maxExchangeAmountSbp', max);
      } else if (paymentSystem === 'bank_account') {
        Vue.set(state, 'activeBankAccount', active);
        Vue.set(state, 'minExchangeAmountBankAccount', min);
        Vue.set(state, 'maxExchangeAmountBankAccount', max);
      } else if (paymentSystem === 'foreign_card') {
        Vue.set(state, 'activeForeignCard', active);
        Vue.set(state, 'minExchangeAmountForeignCard', min);
        Vue.set(state, 'maxExchangeAmountForeignCard', max);
      } else if (paymentSystem === 'foreign_sbp') {
        Vue.set(state, 'activeForeignSbp', active);
        Vue.set(state, 'minExchangeAmountForeignSbp', min);
        Vue.set(state, 'maxExchangeAmountForeignSbp', max);
      } else if (paymentSystem === 'sim') {
        Vue.set(state, 'activeSim', active);
        Vue.set(state, 'minExchangeAmountSim', min);
        Vue.set(state, 'maxExchangeAmountSim', max);
      } else if (paymentSystem === 'qr') {
        Vue.set(state, 'activeQR', active);
        Vue.set(state, 'minExchangeAmountQR', min);
        Vue.set(state, 'maxExchangeAmountQR', max);
      }
    },
    [CHANGE_EXCHANGE_ONLINE_STATUS]: (state, { online }) => {
      Vue.set(state, 'online', online);
    },
    [LOAD_INTERBANKS]: (state, { data }) => {
      if (data) {
        Vue.set(state.interBanks, 'enabled', data.enabled || []);
        Vue.set(state.interBanks, 'disabled', data.disabled || []);
      }
    },
    [LOAD_QR_INTERBANKS]: (state, { data }) => {
      if (data) {
        Vue.set(state.qrInterBanks, 'enabled', data.enabled || []);
        Vue.set(state.qrInterBanks, 'disabled', data.disabled || []);
      }
    },
    [LOAD_EXCHANGE_STATS]: (state, { data }) => {
      if (data?.success) {
        Vue.set(state, 'stats', data.data);
      }
    },
    [RESET_EXCHANGE]: (state) => {
      Vue.set(state, 'name', '');
      Vue.set(state, 'balance', 0);
      Vue.set(state, 'wallet', '');
      Vue.set(state, 'active', false);
      Vue.set(state, 'minExchangeAmount', 0);
      Vue.set(state, 'maxExchangeAmount', 0);
      Vue.set(state, 'activeSbp', false);
      Vue.set(state, 'minExchangeAmountSbp', 0);
      Vue.set(state, 'maxExchangeAmountSbp', 0);
      Vue.set(state, 'activeBankAccount', false);
      Vue.set(state, 'minExchangeAmountBankAccount', 0);
      Vue.set(state, 'maxExchangeAmountBankAccount', 0);
      Vue.set(state, 'activeForeignCard', false);
      Vue.set(state, 'minExchangeAmountForeignCard', 0);
      Vue.set(state, 'maxExchangeAmountForeignCard', 0);
      Vue.set(state, 'activeForeignSbp', false);
      Vue.set(state, 'minExchangeAmountForeignSbp', 0);
      Vue.set(state, 'maxExchangeAmountForeignSbp', 0);
      Vue.set(state, 'activeSim', false);
      Vue.set(state, 'minExchangeAmountSim', 0);
      Vue.set(state, 'maxExchangeAmountSim', 0);
      Vue.set(state, 'activeQR', false);
      Vue.set(state, 'minExchangeAmountQR', 0);
      Vue.set(state, 'maxExchangeAmountQR', 0);
      Vue.set(state, 'deeplinksBanks', []);
      Vue.set(state, 'qrBanks', []);
    },
  },
};
